import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocTopic = async ({ docId, topic }) => {
  let url = `/Docs/topic/${docId}`;

  if (topic?.trim()) {
    url += `?topic=${topic}`;
  }

  return await request.put(
    url,
    null,
    'При изменении произвольной темы документа произошла ошибка',
    'Error'
  );
};

const useChangeDocTopic = () => {
  const mutation = useMutation(changeDocTopic, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocTopic: mutation.isLoading,
    changeDocTopic: mutation.mutateAsync,
  };
};
export default useChangeDocTopic;
